<app-view-title mode="split"
                webMode="{{ webmode }}"
                Title="{{ 'Intellitrailer.Booking.SelectObject.TitleType' | translate : 'Choose trailer type' }}">
</app-view-title>

<view-content [centered]="true" [nopadding]="true">
  <div mobile-content>
    @if (!loadingImg && !categorySelected) {
    <img src="/../../../../assets/Images/trailer-large.png" />
    } @else if (!loadingImg && bookingState.objectCategory?.ImageUri) {
    <img src="{{bookingState.objectCategory.ImageUri}}" />
    }
    <p>
      <span *ngFor="let item of dimensions">
        {{ item.Shorthand | translate }}: {{ item.Name | translate }}
      </span><br />
      <span *ngFor="let item of weights">
        {{ item.Shorthand | translate }}: {{ item.Name | translate }}
      </span>
    </p>
  </div>

  <content-header>
    <p>{{ bookingState.booking?.PickupLocation?.Name }}</p>
    @if (availableOptions.length > 0) {
    <h1>{{ 'Intellitrailer.Booking.SelectObject.SelectObject' | translate : 'Select trailer' }}</h1>
    } @else if (Settings.clientSettings.ShowNearbyOptions) {
    <h1>{{ 'Intellitrailer.Booking.SelectObject.AvailableOptions' | translate : 'Available Options' }}</h1>
    } @else {
    <h1>{{ 'Intellitrailer.Booking.SelectObject.NoAvailableObject' | translate : 'No available trailers' }}</h1>
    }
  </content-header>

  @if (nearByOptions) {
  <div class="nearby-options-container">
    @if (isNextSlotAvailable) {
    <app-card>
      <p>
        {{ 'Intellitrailer.Booking.SelectObject.NextAvailableTimeInfo' | translate : 'We found no trailer matching your request. The first available time is at ' }}
        <b>{{ nearByOptions.AvailableNextSlot | date : 'yyyy-MM-dd HH:mm' }}</b>
      </p>

      <button mat-raised-button (click)="selectNextSlot()">
        {{ 'Intellitrailer.Booking.Components.BookingOption.OkChoose' | translate : 'Ok, choose '}}{{ nearByOptions.AvailableNextSlot | date : 'HH:mm' }}
      </button>
    </app-card>

    <a (click)="showMoreSlots()" class="link">
      {{ 'Intellitrailer.Booking.Components.BookingOption.ShowAllAvailableTimes' | translate : 'Show all available times' }}
    </a>
    } @else {
    <p>
      {{ 'Intellitrailer.Booking.SelectObject.NoTrailerAvailableInfo' | translate : 'We found no trailer matching your request.' }}
    </p>
    }

    @if (nearByOptions.NearByLocations.length > 0 || nearByOptions.OtherCategoryObjectTypes.length > 0) {
    <title-with-divider>
      <h1>
        {{ 'Intellitrailer.Booking.Components.BookingOption.AvailableAlternatives' | translate : 'Available Alternatives' }}
      </h1>
    </title-with-divider>
    }

    <mat-tab-group (selectedTabChange)="onNearByTabChange($event)">
      @if (nearByOptions.OtherCategoryObjectTypes.length > 0) {
      <mat-tab label="{{ 'Intellitrailer.Booking.Components.BookingOption.Availablle Models' | translate : 'Available Models ' }}">
        <div *ngFor="let type of nearByOptions.OtherCategoryObjectTypes">
          @if(type) {
          <list-item (click)="changeModel(type)">
            <img src="{{ type.PictureUri }}" />
            <div>
              <h2>{{ type.Alias }}</h2>
              <small *ngFor="let item of dimensions">
                @if(item.Value) { {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate}} }
              </small><br />
              <small *ngFor="let item of weights">
                @if(item.Value) { {{ item.Shorthand | translate }}: {{ item.Value }}{{ item.Unit | translate}} }
              </small>
            </div>
          </list-item>
          }
        </div>
      </mat-tab>
      }
      @if (nearByOptions.NearByLocations.length > 0) {
      <mat-tab label="{{ 'Intellitrailer.Booking.Components.BookingOption.ShowNearbyLocations' | translate : 'Show Nearby Locations' }}">
        <div *ngFor="let loc of nearByOptions.NearByLocations">
          <div class="row" (click)="changeLocation(loc)">
            <small class="col-8 text-start">{{ loc.Name }}</small>
            <small class="col-4">{{ loc.Distance | number : '0.1-1' }}km</small>
          </div>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  </div>
  }
  @if (loading) {
  <div class="select-object-spinner">
    <mat-spinner diameter="70"></mat-spinner>
  </div>
  } @else {
  <div class="booking-option">
    <div *ngFor="let option of availableOptions"
         [class.is-booked]="option.isBooked "
         (click)="!option.isBooked && selectOption(option)">
      @if(option.isBooked && showUnavailableOptions) {
      <div *ngIf="option.isBooked" class="unavailable">
        <div class="unavailableMessage">
          <mat-icon>lock</mat-icon>
          {{ 'Intellitrailer.Booking.SelectObject.Unavailable' | translate : 'Unavailable' }}
        </div>
      </div>
      }
      @if(showUnavailableOptions) {
      <app-booking-option [booking]="option"></app-booking-option>
      }
    </div>
  </div>
  }
</view-content>
<!--<div class="view-actions white-fade-out-bg" *ngIf="(bookingState && bookingState.booking && bookingState.booking.Id && bookingState.booking.PrimaryObjectTypeId)">
  <button *ngIf="!loading" type="button" mat-raised-button (click)="next()" [disabled]="!bookingState.booking.PrimaryType">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</div>-->
